"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var classnames_1 = __importDefault(require("classnames"));
var Telemetry_1 = require("Common/Telemetry/Telemetry");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var TourOrchestrator_1 = require("Onboarding/Tour/TourOrchestrator/TourOrchestrator");
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var DiscoverStore_1 = __importDefault(require("./DiscoverStore"));
var UpgradeSummary_1 = require("./Trial/UpgradeSummary");
var styles = __importStar(require("./Sidebar.css"));
var bemSidebar = (0, BemBuilder_1.default)("discover-sidebar");
var bemGuide = (0, BemBuilder_1.default)("discover-guide");
var bemTour = (0, BemBuilder_1.default)("discover-tour");
var guides = [
    {
        title: "Designing with Qwilr",
        url: "https://pages.qwilr.com/Qwilr-Guide-Designing-a-Qwilr-Page-BqkNs1TkWkqO",
        image: "guide-design-with-qwilr.png",
    },
    {
        title: "Interactive quotes & e-sign",
        url: "https://pages.qwilr.com/Qwilr-Guide-Quote-Block-Accept-Block-3cJanNq1Rrqw",
        image: "guide-quote-and-esign.png",
    },
    {
        title: "Reusing content",
        url: "https://pages.qwilr.com/Qwilr-Guide-Save-Reuse-your-Qwilr-Content-JHetsi0DSM2c",
        image: "guide-reuse-content.png",
    },
    {
        title: "Securing your page",
        url: "https://pages.qwilr.com/Qwilr-Guide-Securing-Your-Qwilr-Pages-eA5YCiPLQVOs",
        image: "guide-security.png",
    },
    {
        title: "Integrating with HubSpot",
        url: "https://pages.qwilr.com/Qwilr-Guide-Integrating-with-HubSpot-aDjn97wuR66j",
        image: "guide-hubspot.png",
    },
    {
        title: "Integrating with Salesforce",
        url: "https://pages.qwilr.com/Qwilr-Guide-Integrating-with-Salesforce-OmUnfVeuR2mw",
        image: "guide-salesforce.png",
    },
];
var TourBlock = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var tour = _a.tour;
    var tourOrchestrator = (0, inversify_react_1.useInjection)("tourOrchestrator");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var discoverStore = (0, inversify_react_1.useInjection)("discoverStore");
    return (react_1.default.createElement(kaleidoscope_1.ButtonCard, { elevation: 1, className: bemTour(), onClick: function () {
            telemetry.trackOnly("Discover Sidebar Tour Clicked", {
                discover_sidebar_tour_name: tour.telemetryId,
            });
            tourOrchestrator.startTour({ tourId: tour.tourId });
            discoverStore.closeHelp();
        } },
        react_1.default.createElement("img", { className: bemTour("thumbnail"), src: "/Assets/Images/DiscoverQwilr/TourThumbnails/".concat(tour.image), alt: tour.title }),
        react_1.default.createElement("div", { className: bemTour("text-container") },
            react_1.default.createElement(kaleidoscope_1.Label, { size: "s", secondary: true }, ((_b = tourOrchestrator.upNextTour) === null || _b === void 0 ? void 0 : _b.tourId) === tour.tourId ? "Up next" : "Guided Tour"),
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, tour.title)),
        !!tourOrchestrator.isTourCompleted(tour.tourId) ? (react_1.default.createElement(icons_1.Tick, { className: (0, classnames_1.default)(bemTour("checkbox"), bemTour("checkbox", "filled")), size: icons_1.IconSize.Small })) : (react_1.default.createElement(icons_1.FrameCircle, { className: bemTour("checkbox"), size: icons_1.IconSize.Small }))));
});
var GuideBlock = function (guide) {
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    return (react_1.default.createElement("div", { className: bemGuide() },
        react_1.default.createElement(kaleidoscope_1.LinkCard, { href: guide.url, className: bemGuide("thumbnail"), target: "_blank", onClick: function () {
                telemetry.trackOnly("Discover Sidebar Guide Clicked", {
                    discover_sidebar_guide_name: guide.title,
                });
            } },
            react_1.default.createElement("img", { className: styles.guideThumbnailImage, src: guide.image, alt: guide.title })),
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" }, guide.title)));
};
var Sidebar = (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contentRef = react_1.default.createRef();
        _this.throttledScroll = (0, lodash_1.throttle)(function () {
            _this.isContentScrolled = _this.contentRef.current.scrollTop !== 0;
        }, 100);
        _this.isContentScrolled = false;
        _this.tourListScrollIndex = 0;
        _this.scrollTourList = function (direction) {
            _this.tourListScrollIndex = (0, lodash_1.clamp)(_this.tourListScrollIndex + (direction === "left" ? -1 : 1), 0, _this.tours.length - 1);
        };
        return _this;
    }
    Object.defineProperty(Sidebar.prototype, "tours", {
        get: function () {
            var _this = this;
            var tours = Object.values(this.tourOrchestrator.tours).filter(function (tour) { return tour.enabled; });
            if (this.tourOrchestrator.upNextTour) {
                var index = tours.findIndex(function (tour) { return tour.tourId === _this.tourOrchestrator.upNextTour.tourId; });
                var upNext = tours.splice(index, 1);
                return upNext.concat(tours);
            }
            return tours;
        },
        enumerable: false,
        configurable: true
    });
    Sidebar.prototype.componentDidMount = function () {
        this.contentRef.current.addEventListener("scroll", this.throttledScroll);
    };
    Sidebar.prototype.componentWillUnmount = function () {
        this.throttledScroll.cancel();
        this.contentRef.current.removeEventListener("scroll", this.throttledScroll);
    };
    Sidebar.prototype.render = function () {
        var _a;
        var _this = this;
        return (react_1.default.createElement("div", { className: bemSidebar() },
            react_1.default.createElement(kaleidoscope_2.RainbowBar, { isTopRounded: false }),
            react_1.default.createElement("div", { className: bemSidebar("header") },
                react_1.default.createElement(icons_1.Discover, { className: (0, classnames_1.default)(bemSidebar("header-item"), bemSidebar("icon")) }),
                react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "4" }, "Discover Qwilr"),
                react_1.default.createElement(kaleidoscope_1.IconButton, { className: bemSidebar("close-button"), icon: react_1.default.createElement(icons_1.Close, null), onClick: function () {
                        _this.discoverStore.closeHelp();
                        _this.telemetry.trackOnly("Discover Sidebar Dismissed");
                    }, "aria-label": "Close" })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(bemSidebar("content"), (_a = {}, _a[bemSidebar("content", "scrolled")] = this.isContentScrolled, _a)), ref: this.contentRef },
                !!this.trial.isOnTrial() && (react_1.default.createElement("div", { className: bemSidebar("trial-summary") },
                    react_1.default.createElement(UpgradeSummary_1.UpgradeSummary, null))),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(bemSidebar("container")) },
                    react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5" }, "\u2728 Getting Started"),
                    react_1.default.createElement("div", { className: bemSidebar("tours") },
                        react_1.default.createElement(react_transition_group_1.Transition, { in: this.tourListScrollIndex !== 0, mountOnEnter: true, unmountOnExit: true, timeout: kaleidoscope_3.AnimationDuration.Short }, function (status) { return (react_1.default.createElement(kaleidoscope_1.IconButton, { className: (0, classnames_1.default)(bemSidebar("tours-slider-button"), bemSidebar("tours-slider-button", status), bemSidebar("tours-slider-button", "left")), icon: react_1.default.createElement(icons_1.ChevronLeft, null), isRound: true, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function () { return _this.scrollTourList("left"); } })); }),
                        react_1.default.createElement(react_transition_group_1.Transition, { in: this.tourListScrollIndex !== this.tours.length - 1, mountOnEnter: true, unmountOnExit: true, timeout: kaleidoscope_3.AnimationDuration.Short }, function (status) { return (react_1.default.createElement(kaleidoscope_1.IconButton, { className: (0, classnames_1.default)(bemSidebar("tours-slider-button"), bemSidebar("tours-slider-button", status), bemSidebar("tours-slider-button", "right")), icon: react_1.default.createElement(icons_1.ChevronRight, null), isRound: true, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function () { return _this.scrollTourList("right"); } })); }),
                        react_1.default.createElement("div", { className: bemSidebar("tours-slider"), style: { "--slider-offset": this.tourListScrollIndex } }, this.tours.map(function (tour) { return (react_1.default.createElement(TourBlock, { key: tour.tourId, tour: tour })); })))),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(bemSidebar("container")) },
                    react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5" }, "Guides"),
                    react_1.default.createElement("div", { className: bemSidebar("guides") }, guides.map(function (guide) { return (react_1.default.createElement(GuideBlock, { title: guide.title, url: guide.url, image: "/Assets/Images/DiscoverQwilr/GuideThumbnails/".concat(guide.image), key: guide.title })); })))),
            this.discoverStore.isBeaconEnabled && (react_1.default.createElement("div", { className: bemSidebar("footer") },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
                        _this.discoverStore.openChat();
                        _this.telemetry.trackOnly("Discover Sidebar Contact Support Clicked");
                    }, size: kaleidoscope_1.ButtonSize.Small },
                    react_1.default.createElement(icons_1.Chat, null),
                    " Contact support"),
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
                        _this.telemetry.trackOnly("Discover Sidebar Browse Help Clicked");
                    }, href: function () { return "https://help.qwilr.com"; }, size: kaleidoscope_1.ButtonSize.Small },
                    react_1.default.createElement(icons_1.Docs, null),
                    " Browse help docs")))));
    };
    var _a, _b, _c, _d;
    __decorate([
        (0, inversify_react_1.resolve)("discoverStore"),
        __metadata("design:type", typeof (_a = typeof DiscoverStore_1.default !== "undefined" && DiscoverStore_1.default) === "function" ? _a : Object)
    ], Sidebar.prototype, "discoverStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("trial"),
        __metadata("design:type", Object)
    ], Sidebar.prototype, "trial", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("telemetry"),
        __metadata("design:type", typeof (_b = typeof Telemetry_1.Telemetry !== "undefined" && Telemetry_1.Telemetry) === "function" ? _b : Object)
    ], Sidebar.prototype, "telemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_c = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _c : Object)
    ], Sidebar.prototype, "usingFeature", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("tourOrchestrator"),
        __metadata("design:type", typeof (_d = typeof TourOrchestrator_1.TourOrchestrator !== "undefined" && TourOrchestrator_1.TourOrchestrator) === "function" ? _d : Object)
    ], Sidebar.prototype, "tourOrchestrator", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Sidebar.prototype, "isContentScrolled", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Sidebar.prototype, "tourListScrollIndex", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Sidebar.prototype, "scrollTourList", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], Sidebar.prototype, "tours", null);
    Sidebar = __decorate([
        mobx_react_1.observer
    ], Sidebar);
    return Sidebar;
}(react_1.default.Component));
exports.Sidebar = Sidebar;
